/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 26/12/2021
 */
import BaseObject from "@shared/BaseObject.js";

let defaultOptions = {
	"already_connected": "This calendar is already connected. Try connecting a different one.",
	"missing_scope": "Can't complete the connection. Please try again and make sure to grant all the requested permissions to Qwoach.",
	"connect_cancelled": "Calendar wasn't connected because you've cancel the process."
}

export default class UrlResponseReader extends BaseObject {

	baseViewComponent

	constructor(baseViewComponent) {
		super();
		this.baseViewComponent = baseViewComponent
	}

	async processUrlResponse(options = {}){
		let isSuccess = true
		options = {...defaultOptions, ...options}
		let responseParam = this.baseViewComponent.$route.query.res || this.baseViewComponent.$route.query.auth_res
		let responseReason = this.baseViewComponent.$route.query.res_reason
		console.log("readResponse: responseParam = ", responseParam, ", responseReason = ", responseReason)
		let shouldSkipAlreadyConnected = responseReason === "already_connected" && options.allowAlreadyConnected
		if(responseParam === "error" && !shouldSkipAlreadyConnected){
			let errorMessage = options[responseReason] || "Something went wrong. Can't complete this action."
			this.baseViewComponent.toastWarn(errorMessage, 5000)
			isSuccess = false
		}
		if(responseParam === "success"){
			let message = options.success || "Success"
			this.baseViewComponent.toast(message)
		}
		await this.baseViewComponent.removeQuery(["res", "auth_res", "res_reason"])

		return isSuccess

	}
}
